// extracted by mini-css-extract-plugin
export default {"loginButtonContainer":"LoginWithExternalIdentityProviderView_loginButtonContainer__v7K8i"};